import { render, staticRenderFns } from "./SmallFacePills.vue?vue&type=template&id=cf6f923c&"
import script from "./SmallFacePills.vue?vue&type=script&lang=js&"
export * from "./SmallFacePills.vue?vue&type=script&lang=js&"
import style0 from "./SmallFacePills.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports